import { defineMessages } from 'react-intl';

export const planPriceDisplayMessages = defineMessages({
  perUserMonth: {
    defaultMessage: 'user/month.',
    id: '9pDltgsnSU',
    description: 'Price caption under a plan monthly rate',
  },
  excludeGst: {
    defaultMessage: 'Exc. GST',
    id: 'tFu6BT7Kra',
    description: 'Tax caption under a plan price for AU/NZ markets',
  },
  excludeTax: {
    defaultMessage: 'Excl. tax',
    id: '1MyHp0QgC+',
    description: 'Generic tax caption under a plan price outside AU/NZ',
  },
});
